import clip from 'text-clipper'

export abstract class StringFormatter {
  /**
   * Capitalize the first letter of each word in a string
   * Lowercase the rest of the word
   * @param str
   * @returns
   * @example
   * toTitleCase("hello world") // "Hello World"
   * toTitleCase("HELLO WORLD") // "Hello World"
   * toTitleCase("hello WORLD") // "Hello World"
   */
  static toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  /**
   * Capitalize the first letter of a string
   * @param str
   * @returns
   * @example
   * capitalize("hello world") // "Hello world"
   * capitalize("HELLO WORLD") // "Hello world"
   */
  static capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }

  /**
   * Shorten text to a specified length
   * @param text
   * @param maxLength
   * @param options
   * @returns
   * @example
   * shortenText("hello world", 5) // "hello..."
   * shortenText("hello world", 5, {ellipsis: false}) // "hello"
   */
  static shortenText(text: string, maxLength: number, options?: object): string {
    return clip(text, maxLength, {
      breakWords: true,
      ...options
    })
  }

  /**
   * Add a required asterisk to a label
   * @param label
   * @returns
   * @example
   * isRequired("Name") // "Name *"
   */
  static isRequired(label: string, required?: boolean): string {
    return required ? `${label}*` : label
  }
}
